module.exports = __webpack_public_path__ + "img/promotions-cashback.f8b69418.png";